if (!customElements.get('lus-proof-gallery')) {
  customElements.define('lus-proof-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mounted === 'true') return;
      this.dataset.mounted = 'true';
      this.slides = [...this.querySelectorAll('[data-lus-proof-slide]')];
      this.tabs = [...this.querySelectorAll('[data-lus-proof-tab]')];
      this.descriptors = [...this.querySelectorAll('[data-lus-proof-descriptor]')];
      this.previous = this.querySelector('[data-lus-proof-previous]');
      this.next = this.querySelector('[data-lus-proof-next]');
      this.stage = this.querySelector('[data-lus-proof-stage]');
      this.index = 0;

      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.show(Number(tab.dataset.index))));
      this.previous?.addEventListener('click', () => this.show(this.index - 1));
      this.next?.addEventListener('click', () => this.show(this.index + 1));
      this.querySelector('[role="tablist"]')?.addEventListener('keydown', (event) => this.onKeydown(event));
      this.stage?.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.stage?.addEventListener('pointerup', (event) => this.onPointerUp(event));
      this.stage?.addEventListener('pointercancel', () => this.pointerStart = null);
      this.show(0);
    }

    show(nextIndex, focusTab = false) {
      if (!this.slides.length) return;
      const index = Math.max(0, Math.min(this.slides.length - 1, nextIndex));
      this.index = index;

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        if (active) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });

      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });

      this.descriptors.forEach((descriptor, descriptorIndex) => {
        const active = descriptorIndex === index;
        descriptor.classList.toggle('is-active', active);
        descriptor.setAttribute('aria-hidden', String(!active));
      });

      if (this.previous) this.previous.disabled = index === 0;
      if (this.next) this.next.disabled = index === this.slides.length - 1;
      if (focusTab) this.tabs[index]?.focus();
    }

    onKeydown(event) {
      const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') this.show(0, true);
      else if (event.key === 'End') this.show(this.slides.length - 1, true);
      else this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
    }

    onPointerDown(event) {
      if (event.pointerType === 'mouse') return;
      this.pointerStart = { x: event.clientX, y: event.clientY };
    }

    onPointerUp(event) {
      if (!this.pointerStart) return;
      const deltaX = event.clientX - this.pointerStart.x;
      const deltaY = event.clientY - this.pointerStart.y;
      this.pointerStart = null;
      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      this.show(this.index + (deltaX < 0 ? 1 : -1));
    }
  });
}
